import * as CardApplication from '@/src/experiences/card-application'
import { withFinishedApplicationGate } from '@/src/experiences/card-application/withFinishedApplicationGate'
import { Redirect } from 'expo-router'

export default withFinishedApplicationGate(
  CardApplication.Components.withCardPlatform(
    CardApplication.Screens.DeniedScreen,
    CardApplication.Screens.Highnote.ApplicationDenied,
  ),
  (finishedStatus) => (finishedStatus !== 'DENIED' ? <Redirect href="/main/card" /> : undefined),
)
